export default __webpack_public_path__ + "static/media/service.917fc6aa.svg";